module.exports = __webpack_public_path__ + "static/media/OutliersMCQ3_3.db615b60.svg";